import React from "react";

import { Box } from "app/layout/components";
import { NewsListItem } from "app/news/interfaces";
import { LinkWithTime } from "app/links/LinkWithTime/LinkWithTime";
import { formatDateOrTime } from "app/formatting/functions";
import { newsDetailUrl } from "app/news/urls";
import { SectionHeader } from "app/layout/SectionHeader/SectionHeader/SectionHeader";
import { SectionHeaderLink } from "app/layout/SectionHeader/SectionHeaderLink/SectionHeaderLink";
import { VisualHeadlineSize } from "app/layout/Headline/Headline";

import { clientConfig } from "app/config";

interface Props {
    news: NewsListItem[];
    instrumentName?: string;
    hideHeaderLink?: boolean;
    headlineOverride?: string;
}

const timeFormatter = (d: string | number | Date): string => {
    return formatDateOrTime(d, true);
};

export const NewsContentBlock = ({ news, hideHeaderLink, headlineOverride }: Props) => {
    const headerLink = hideHeaderLink ? null : (
        <SectionHeaderLink title="Mehr Nachrichten" url={clientConfig.newsUrl} />
    );
    return (
        <Box section className={"newsList"}>
            <SectionHeader
                headline={headlineOverride ? headlineOverride: "Nachrichten"}
                visualHeadlineSize={VisualHeadlineSize.MEDIUM}
                sectionControls={headerLink}
            />

            {news.map(newsItem => {
                return (
                    <LinkWithTime
                        key={newsItem.id}
                        title={newsItem.title}
                        time={newsItem.time.toString()}
                        url={newsDetailUrl(newsItem.id, newsItem.title)}
                        timeFormatter={timeFormatter}
                    />
                );
            })}
        </Box>
    );
};
